import {
    postData,
    getData,
    patchData,
    deleteData
} from './Services'

export const getFavoritosPaginated = async (page, perPage, userId, orderBy, orden) => {
    const res = await getData(`/favoritos?page=${page}&perPage=${perPage}&user_id=${userId}&orderBy=${orderBy}&orden=${orden}`);
    return res
}


export const getFavoritosByUserID = async (user_id) => {
  const res = await getData(`/favoritos/user/${user_id}`);
  return res;
};

export const postFavorito = async (body) => {
    const res = await postData('/favoritos', body, false, "El producto se agrego correctamente")
    return res
}

export const deleteFavorito = async (id) => {
    const res = await deleteData(`/favoritos/${id}`, false, "El producto se quito correctamente")
    return res
}

export const updateFavorito = async (id, body) => {
    const res = await patchData(`/favoritos/${id}`, body, false)
    return res
}


export const getFavoritoByID = async (id) => {
    const res = await getData(`/favoritos/${id}`)
    return res
}
